import { motion } from "framer-motion";

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="/" className="flex items-baseline gap-1" data-testid="navbar-logo">
          <span className="font-serif-display text-xl font-bold tracking-tight text-slate-50">ECH</span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-emerald-400 font-semibold">IDR</span>
        </a>
      </div>
    </motion.header>
  );
}
